<template>
  <div>
    <!-- 선택된 상품 -->
    <div class="columns is-multiline"
         v-for="(product, idx) in products"
         :key="'prod'+idx"
         style="border: 1px solid #ddd; border-radius: 4px; position: relative; padding: 4px; margin: 0 0 20px">

      <i class="material-icons"
         @click="delProduct(idx)"
         style="position: absolute; top: 6px; right: 4px; font-size: 1rem; cursor: pointer">close</i>

      <div class="column is-full">
        <admin-form-item label="카테고리*">
          <div class="content">
            <div class="columns is-multiline">
              <div class="column is-3">
                <lp-adm-drop-input :data.sync="catArr1"
                                   @onSelect="res=>selCategory1(res, idx)"
                                   :selectVal="selectedCategory(product.category1_id, 'cat1', idx)"
                                   placeholder="검색 후 선택" listAlign="center"
                                   style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
                <!--<input class="input"
                       style="width:250px"
                       :value="selectedCategory(product.category1_id, 'cat1', idx)"
                       v-else
                       type="text" :disabled="true">-->
              </div>

              <div class="column is-3">
                <lp-adm-drop-input :data.sync="product.cat2"
                                   @onSelect="res=>selCategory2(res, idx)"
                                   :selectVal="selectedCategory(product.category2_id, 'cat2', idx)"
                                   placeholder="검색 후 선택" listAlign="center"
                                   style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
                <!--<input class="input"
                       style="width:250px"
                       :value="selectedCategory(product.category2_id, 'cat2', idx)"
                       v-else
                       type="text" :disabled="true">-->
              </div>

              <div class="column is-3">
                <lp-adm-drop-input :data.sync="product.cat3"
                                   @onSelect="res=>selCategory3(res, idx)"
                                   :selectVal="selectedCategory(product.category3_id, 'cat3', idx)"
                                   placeholder="검색 후 선택" listAlign="center"
                                   style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
                <!--<input class="input"
                       style="width:250px"
                       :value="selectedCategory(product.category3_id, 'cat3', idx)"
                       v-else
                       type="text" :disabled="true">-->
              </div>
            </div>
          </div>
        </admin-form-item>
      </div>

      <div class="column is-half">
        <admin-form-item label="상품명*">
          <input class="input"
                 style="width:250px"
                 @input="res=> product.name = res.target.value"
                 placeholder="상품명을 입력해주세요."
                 :value="product.name"
                 type="text">
        </admin-form-item>
      </div>


      <div class="column is-half">
        <admin-form-item label="판매 가격">
          <input class="input"
                 style="width:250px"
                 @input="e=> setPrice(e, idx, 10)"
                 placeholder="판매 가격을 입력해주세요."
                 :value="product.price"
                 type="number">
        </admin-form-item>
      </div>

      <div class="column is-full">
        <admin-form-item label="상품 대표 이미지">
          <input-img :url.sync="product.first_img" :idx="(idx+1)*1111"></input-img>
        </admin-form-item>
      </div>

      <div class="column is-full">
        <admin-form-item label="상품 이미지">
          <div class="flex">
            <draggable>
              <input-img style="display: inline-block;" v-bind:key="'img'+idx"
                         v-for="(img, idx) in product.imgs"
                         :idx="(idx+1)*1000"
                         @addImg="product.imgs.push('')"
                         :url.sync="product.imgs[idx]"></input-img>
            </draggable>
            <div class="lp-add-img" @click="product.imgs.push('')">
              <i class="material-icons">add</i>
            </div>
          </div>
        </admin-form-item>
      </div>

      <div class="column is-full">
        <admin-form-item label="상품 한줄소개">
          <input class="input"
                 @input="res=> product.simple_desc = res.target.value"
                 placeholder="상품 관련 간단한 소개를 하는 곳 입니다."
                 :value="product.simple_desc"
                 type="text">
        </admin-form-item>
      </div>

      <div class="column is-full">
        <admin-form-item label="상품 상세정보">
          <lp-editor :text.sync="product.info"></lp-editor>
        </admin-form-item>
      </div>

      <div class="column is-full" v-if="$route.query.id || !isAdmin">
        <admin-form-item>
          <button class="button"
                  style="width:auto"
                  v-if="!product.isNew"
                  @click="$router.push(getPath('product/create?id='+product.id))"
          >상품 상세페이지 가기
          </button>
        </admin-form-item>
      </div>
    </div>
    <div class="columns is-multiline" v-if="products.length < 3">
      <div class="column is-full">
        <div class="flex">
          <button class="button"
                  style="width:100%; background:whitesmoke;color: #787878;margin:0 4px"
                  @click="addProduct('new')">+ 새 간편 상품 추가
          </button>
          <button class="button"
                  style="width:100%; background:whitesmoke;color: #787878;margin:0 4px"
                  @click="addProduct('old')">+ 파트너 정보와 동일한 상품 추가
          </button>
        </div>
      </div>
    </div>

    <modal name="deleteProdModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div>간편상품을 삭제하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('deleteProdModal')">취소</button>
          <button class="button is-primary" @click="delProd">확인</button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
  import draggable from 'vuedraggable'
  import LpAdmDropInput from "../common/LpAdmDropInput";
  import InputImg from "../common/InputImg";
  import LpEditor from "../common/LpEditor";
  import LpAddress from "../common/LpAddress";
  import LpCheckBool from "../common/LpCheckBool";

  export default {
    props: {
      products: {
        type: Array
      },
      partner: {
        type: Object
      },

    },
    components: {
      LpCheckBool,
      LpAddress,
      LpEditor,
      InputImg,
      draggable,
      LpAdmDropInput
    },
    data() {
      return {
        catArr1: [],
        catArr2: [],
        catArr3: [],
        inquiry_conversion_type: 0,
        payment_type: 0,
        order_conversion_type: 0,
        basic_package: '',
        delProductId: 0
      }
    },
    watch: {
      products(n) {
        if(n.length>0) {
          this.getCategory();
          this.getBasicPackage();
        }
      }
    },
    mounted() {
      this.getCategory();
      this.getBasicPackage();
    },
    methods: {
      setPrice(e, idx, max_length) {

        this.products[idx].price = e.target.value.length > max_length ? e.target.value.substr(0,max_length)
                                    : e.target.value;
      },
      get_cat2(idx) {
        return this.catArr2.filter(i => i.parent === this.products[idx].category1_id);
      },
      get_cat3(idx) {
        return this.catArr3.filter(i => i.parent === this.products[idx].category2_id);
      },
      getCategory() { // 카테고리 가져오기
        this.$axios.get(this.getUrl('category'))
          .then(res => {

            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let i = 0; i < res.data.length; i++) {
              let cat = res.data[i];
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name, packages: cat.packages});

              for (let j = 0; j < cat.child.length; j++) {
                let cat2 = cat.child[j];
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let k = 0; k < cat2.child.length; k++) {
                  let cat3 = cat2.child[k];
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }
            for(let x=0; x<this.products.length; x++){
              if(this.products[x].category1_id) {
                this.products[x].cat2 = this.get_cat(this.catArr2, this.products[x].category1_id);
              }
              if(this.products[x].category2_id) {
                this.products[x].cat3 = this.get_cat(this.catArr3, this.products[x].category2_id);
              }
            }
            // this.$emit('getData');
          });
      },
      // 서비스 정보에 기본으로 선택된 패키지 가져오기
      getBasicPackage() {
        let setting = this.$store.getters.getServiceSettingProduct
        this.basic_package = setting.basic_package;
        this.order_conversion_type = setting.order_conversion_type;
        this.inquiry_conversion_type = setting.inquiry_conversion_type;
        this.payment_type = setting.payment_type;
      },
      selCategory1(res, idx) {
        this.products[idx].category1_id = res.value;
        this.products[idx].category2_id = '';
        let service_packages = this.$store.getters.getPackages;

        let selectedPack = 0;
        this.catArr1.forEach(item=>{
          if(item.value===res.value && item.packages.length>0) {
            for (let j=0; j<item.packages.length; j++){
              if(item.packages[j]==='all') {
                // 서비스 기본 선택된 팩이 카테고리의 상품 종류에 있을 경우, 선택
                if(this.basic_package){
                  selectedPack = find(service_packages, 'name', this.basic_package);
                }
                else {
                  selectedPack=undefined;
                }
                //break;
              }
              else {
                // 서비스 기본 선택된 팩이 카테고리의 상품 종류에 있을 경우, 선택
                if(this.basic_package && item.packages.indexOf(this.basic_package) > -1) {
                  selectedPack = find(service_packages, 'name', this.basic_package);
                }
                // 없을 경우 카테고리 상품 종류의 맨첫번째 가져오기
                else {
                  selectedPack = find(service_packages, 'name', item.packages[j]);
                }
              }
            }
          }
        })
        this.products[idx].selectedPack = selectedPack;
        this.changeConversionList(idx);

        this.products[idx].cat2 = this.get_cat2(idx);
      },
      selCategory2(res, idx) {
        this.products[idx].category2_id = res.value;
        this.products[idx].category3_id = '';
        this.products[idx].cat3 = this.get_cat3(idx);

      },
      selCategory3(res, idx) {
        this.products[idx].category3_id = res.value;

      },
      selectedCategory(category_id, type, idx) {
        if (!category_id) {
          return '';
        }
        if (type === 'cat1') {
          for (let i = 0; i < this.catArr1.length; i++) {
            if (this.catArr1[i].value === category_id) {
              return this.catArr1[i].label;
            }
          }
        }
        else if (type === 'cat2') {
          for (let i = 0; i < this.catArr2.length; i++) {
            if (this.catArr2[i].value === category_id) {
              return this.catArr2[i].label;
            }
          }
        }
        else if (type === 'cat3') {
          for (let i = 0; i < this.catArr3.length; i++) {
            if (this.catArr3[i].value === category_id) {
              return this.catArr3[i].label;
            }
          }
        }
      },
      // 주문 전환 목록
      changeConversionList(idx) {
        let selectedPack = this.products[idx].selectedPack;
        this.order_conversion_arr = [
          { label:'없음',value:0 },
          { label: selectedPack.kor_name, value: selectedPack.id }
        ];
        this.products[idx].order_conversion_type = selectedPack.id;

        // // 모임참여
        // if(this.selectedPack.name==='meet'){
        //   this.prod.enable_meet = true;
        //   this.$axios.get('public/meet/form/simple').then(res=>{
        //     this.meetFormArr = res.data;
        //   })
        // }
        //
        // // 상담신청
        // else if(this.selectedPack.name==='counsel'){
        //   this.prod.enable_counsel = true;
        //
        //   this.$axios.get('public/counsel/form/simple').then(res=>{
        //     this.counselFormArr = res.data;
        //   })
        // }
      },
      delProd(){
        this.$axios.delete(this.getUrl(`product/${this.delProductId}`))
          .then(res=>{
            if(res.status===200) {
              this.$modal.hide('deleteProdModal');
              this.delProductId = 0;
              this.$emit('getData');
            }
          })
      },
      // 간편 상품 삭제
      delProduct(index) {
        if(!this.products[index].id) {
          this.products.splice(index, 1);
        }
        else {
          this.delProductId = this.products[index].id;
          this.$modal.show('deleteProdModal');
        }
      },
      // 상품 추가
      addProduct(type) {
        if (this.products.length > 3) return;
        // 새로운 상품 추가
        let prod_info = '';
        if(type==='new'){
          prod_info = this.getProdInfo();

        }
        // 파트너와 동일한 상품 추가
        else if(type==='old'){
          prod_info = this.getProdInfo();
          prod_info.imgs = this.partner.imgs;
          prod_info.name = this.partner.name;
          prod_info.simple_desc = this.partner.simple_desc;
          prod_info.info = this.partner.info;
          prod_info.first_img = this.partner.first_img;

        }
        this.products.push(prod_info);
      },
      getProdInfo() {
        // 관리자 경우는 승인 요청과 상관없이 상품 승인 자동
        // 파트너 일경우만 체크함
        let approval_type = 0;
        if(!this.isAdmin) {
          // 상품 승인요청 여부 사용했을 경우
          if(this.isInternalPlugin('product_approval')===true) {
            // 상품 승인 타입 (미승인)
            approval_type = 0;
          }
          // 사용 안할 경우
          else {
            // 상품 승인 타입 (승인)
            approval_type = 1;
          }
        }
        else approval_type = 1;

        let prod_info = '';
        prod_info = {
          isNew: true,
          approval_type: approval_type,
          first_img: '',
          imgs: [''],
          name: '',
          category1_id: '',
          category2_id: '',
          category3_id: '',
          category1_name: '',
          category2_name: '',
          category3_name: '',
          simple_desc: '',
          price: '',
          package: this.basic_package,
          order_conversion_type: this.order_conversion_type,
          inquiry_conversion_type: this.inquiry_conversion_type,
          payment_type: this.payment_type,
          // 카테고리
          catArr1: this.catArr1,
          catArr2: this.catArr2,
          catArr3: this.catArr3,
          cat2: [],
          cat3: [],
          is_simple: true,
          info: '',
          address:{
            sido: '',
            sigungu: '',
            dong: '',
            detail: '',
            post_code: '',
            old: '',
            new: ''
          },
          selectedPack: 0
        }
        return prod_info;
      }
    }
  }
</script>
<style lang="stylus" type="stylus">
  @import '~assets/css/lp_main'
  .lp-tab
    display flex
    padding 10px 24px
    color #555

  .lp-tab-selected
    border: 1px solid #ccc;
    border-bottom: 1px solid #fff;
    color: #555;
    border-radius: 3px;
</style>
